export default __webpack_public_path__ + "static/media/ConnectGNBLandingIcon.e42aec1d.svg";